import UDButton from 'modules/ud-ui/components/button';
import React, { useState } from 'react';
import { StageV2 } from '../../../../../domain/interfaces/stage';
import StageMatrix from './stage-matrix/stage-matrix';
import StageStanding from './stage-standing/stage-standing';

type StageStandingTabsProps = {
  stage: StageV2;
};

enum TabType {
  STANDING = 'standing',
  MATRIX = 'matrix',
}

const StageStandingTabs = ({ stage }: StageStandingTabsProps) => {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.STANDING);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-2">
        <UDButton variant={activeTab === TabType.STANDING ? 'primary' : 'light'} onClick={() => setActiveTab(TabType.STANDING)}>
          Таблица
        </UDButton>
        <UDButton variant={activeTab === TabType.MATRIX ? 'primary' : 'light'} onClick={() => setActiveTab(TabType.MATRIX)}>
          Шахматка
        </UDButton>
      </div>

      {activeTab === TabType.STANDING ? <StageStanding stage={stage} /> : <StageMatrix stage={stage} />}
    </div>
  );
};

export default StageStandingTabs;
